<template>
  <Layout>
    <Title title="Alíquotas Municipais" margin="large" />
    <b-card>
      <IBSRegimeFormMessage />

      <b-row class="d-flex justify-content-end align-items-end row-padding">
        <b-col lg="3" md="12">
          <Label>Alíquota base</Label>
          <InputQuantity id="baseAliq" placeholder="0,10" disabled />
        </b-col>
        <b-col lg="3" md="12">
          <Label>Pesquisar</Label>
          <Input type="text" id="search" @input="handleSearch" />
        </b-col>
      </b-row>

      <table class="table table-striped">
        <thead>
          <tr>
            <th style="width: 15%">Código IBGE</th>
            <th style="width: 68%">Cidade</th>
            <th style="width: 15%; text-align: right">% IBS Municipal</th>
            <th style="width: 10%" />
          </tr>
        </thead>
        <tbody>
          <template v-if="tributations.length">
            <tr v-for="(city, i) in tributations" :key="i">
              <td>{{ city.id }}</td>
              <td>{{ city.description }}</td>
              <td align="right">
                {{ toPercentage(city.defaultMunIBS, 2, 'decimal') }}
              </td>

              <td />
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="5">Nenhum registro encontrado!</td>
            </tr>
          </template>
        </tbody>
      </table>
    </b-card>
  </Layout>
</template>

<script>
import { mapActions } from 'vuex';
import debounce from 'lodash/debounce';

import api from '../../../../../configurations/service';
import Layout from '../../../../../components/Layout';
import Title from '../../../../../components/Title';
import Label from '../../../../../components/Form/Label';
import InputQuantity from '../../../../../components/Form/InputQuantity';
import Input from '../../../../../components/Form/Input';
import IBSRegimeFormMessage from '../../IBSRegime/pages/IBSRegimeFormMessage.vue';
import { numberBR } from '../../../../../core/helpers/formater/number';

export default {
  name: 'FiscalStateTributation',
  components: {
    Layout,
    Title,
    Label,
    InputQuantity,
    Input,
    IBSRegimeFormMessage,
  },
  data() {
    return {
      tributations: [],
    };
  },
  mounted() {
    const getDataInit = async () => {
      this.setLoading(true);
      await this.get();
      this.setLoading(false);
    };
    getDataInit();
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    toPercentage(value) {
      return numberBR(value);
    },
    async get(search = undefined) {
      const { data } = await api(2).post('/fiscal.get-city-tributation', { search });
      this.tributations = data;
    },
    async search(search) {
      await this.get(search);
    },
    handleSearch: debounce(async function handleSearch(search, loading) {
      await this.search(search, loading);
    }, 600),
  },
};
</script>
